import { ILeftVsRightKeys, IRngResultItem } from 'twain-sport-fe-mono';

export const getResultPointsByCourt = (
    results: IRngResultItem[],
    court: ILeftVsRightKeys,
): number => results.find((item) => item.court === court)?.points;
